<template>
    <div class="paper-card flex flex-col gap-4 rounded border border-solid border-grey-40 bg-white px-6 py-4">

        <div class="flex items-center justify-between gap-4">

            <div class="th-tabs th-tabs-bordered th-tabs-md">
                <span class="th-tab th-tab-bordered !text-base" v-for="(item, index) in tabs" :key="index"
                      :class="{ 'th-tab-bordered-active': item.name === activeTab }" @click="() => changeTab(item.name)">
                    {{ item.label }}
                </span>
            </div>

            <button @click="downloadChartAsImage" :disabled="disableUI" class="th-btn th-btn-plain shrink-0">
                <PtIcon class="th-btn-icon fill-grey-450 text-2xl" icon="SolidExport" />
                <span>{{ t('download') }}</span>
            </button>

        </div>

        <div class="relative h-[548px]">
            <BIChart
                :key="activeTab"
                :chartType="chartType"
                ref="graphChart"
                :chartKey="chartKey"
                :isLoading="isFetchLoading"
                :configTaskFunc="chartConfig"
                :dataTaskFunc="getGraphChartData"
                @click="handleDrillDown"
                @visualReady="handleVisualReady"
                class="h-full w-full" />
            <GraphTool key="RelationshipPatent" :formattedZoom="formattedZoom" v-if="!graphChart?.isEmptyChart"/>

        </div>
    </div>
</template>

<script setup lang="ts">
import '@patsnap-ui/icon/assets/VectorGradient.svg';
import { PtIcon } from 'patsnap-biz';
import BIChart from '@/components/BIChart.vue';
import { ref } from 'vue';
import { useCoGraph } from '@/composables/use-co-graph';
import { useI18n } from 'vue-i18n';
import { useGraphTool } from '@/composables/use-graph-tool';
import GraphTool from '@/components/GraphTool.vue';

const { t } = useI18n();
const graphChart = ref<{
    generateChartImage: () => Promise<string>,
    drawChart: () => void,
    isChartLoaded: () => boolean,
    clearSelect: () => void,
    isEmptyChart: boolean
}>();

const {
    tabs,
    activeTab,
    disableUI,
    chartType,
    chartKey,
    chartConfig,
    isFetchLoading,
    getGraphChartData,
    downloadChartAsImage,
    changeTab,
    handleDrillDown,
} = useCoGraph({ graphChart });

const { handleVisualReady, formattedZoom } = useGraphTool()

</script>
